import templateUrl from "emun.customer/scan-badge/scan-badge.htm";
import ScanBadgeController from "emun.customer/scan-badge/scan-badge.controller";
//import resolve from 'ioc/resolve'
import modals from "webmodals/modals";
import "emun.customer/scan-badge/scan-badge.scss";

const ScanBadge = {
  open(options) {
    return modals.open(
      angular.extend(
        {
          size: "lg",
          templateUrl,
          resolve: {
            options: () => options,
          },
          bindToController: true,
          controller: ScanBadgeController,
          controllerAs: "$ctrl",
        },
        (options || {}).modal
      )
    ).result;
  },
};

export default ScanBadge;
